
import React from 'react'
import { useTranslation } from 'react-i18next';
import "./needToReconcile.scss";
const NeedToReconcile = () => {

  const { t } = useTranslation()
  return (
    <div className='container-need'>
      <div className="texts-need">
        <h1>{t("connectors.reconcile.title")}</h1>
        <p>{t("connectors.reconcile.section_text")}</p>
      </div>
    </div>
  )
}

export default NeedToReconcile